import React from 'react';
import styled from 'styled-components';
import { string, bool } from 'prop-types';
import { C_WHITE } from '@bbc/psammead-styles/colours';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "nhmg8j-0"
})(["padding:", " 0 ", ";color:", ";font-weight:700;text-decoration:none;display:", ";"], GEL_SPACING, GEL_SPACING, C_WHITE, function (_ref) {
  var inline = _ref.inline;
  return inline ? 'inline' : 'block';
});
var StyleLinkText = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyleLinkText",
  componentId: "nhmg8j-1"
})(["", ":hover &,", ":focus &{text-decoration:underline;}"],
/* sc-selector */
StyledLink,
/* sc-selector */
StyledLink);

var Link = function Link(_ref2) {
  var text = _ref2.text,
      href = _ref2.href,
      inline = _ref2.inline,
      lang = _ref2.lang;
  return /*#__PURE__*/React.createElement(StyledLink, {
    lang: lang,
    inline: inline,
    href: href
  }, /*#__PURE__*/React.createElement(StyleLinkText, null, text));
};

Link.defaultProps = {
  inline: false,
  lang: null
};
Link.propTypes = {
  href: string.isRequired,
  text: string.isRequired,
  lang: string,
  inline: bool
};
export default Link;